<template>
  <div>
    <v-container class="container--fluid">
      <v-row dense>
        <v-col cols="12">
          <v-card>
            <v-col cols="12">
              <v-row>
                <v-col cols="2" sm="2" md="2" class="pr-3">
                  <v-select
                    v-model="analiysis_typeModel"
                    :items="analiysis_type"
                    label="Raport Tipi"
                  />
                </v-col>

                <v-col cols="1" sm="1" md="1" class="pr-3">
                  <v-select v-model="reportTypeModel" :items="reportType" />
                </v-col>

                <v-col
                  v-if="analiysis_typeModel == 'generalStats'"
                  cols="3"
                  sm="2"
                  md="2"
                  class="pr-3"
                >
                  <v-select
                    v-model="santralModel"
                    :items="santralDataList"
                    label="Santral"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span
                        v-if="index === 0"
                        style="max-width: 120px"
                        class="d-inline-block text-truncate"
                        >{{ item }}</span
                      >
                      <span v-if="index === 1" class="grey--text text-caption"
                        >(+{{ santralModel.length - 1 }})</span
                      >
                    </template>
                  </v-select>
                </v-col>

                <v-col v-else cols="3" sm="2" md="2" class="pr-3">
                  <v-select
                    v-model="santralModel_string"
                    :items="santralDataList"
                    label="Santral"
                  />
                </v-col>

                <v-spacer />

                <v-col cols="1" sm="1" md="1" class="pr-3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        fab
                        dark
                        small
                        color="cyan"
                        v-on="on"
                        @click="exportDocument"
                      >
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <span>Export to Excel</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col v-if="analiysis_typeModel == 'generalStats'" cols="12">
          <v-card>
            <v-col cols="12" class="pl-0 pr-0 pb-1">
              <v-row>
                <v-spacer />

                <v-col
                  v-if="
                    reportTypeModel === 'Monthly' || reportTypeModel === 'Daily'
                  "
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select v-model="yearModel" :items="yearList" label="Yıl" />
                </v-col>

                <v-col
                  v-if="reportTypeModel === 'Daily'"
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select
                    v-model="monthModel"
                    :items="monthList"
                    label="Ay"
                  />
                </v-col>

                <v-col
                  v-if="
                    reportTypeModel == 'Hourly' || reportTypeModel == 'Minute'
                  "
                  cols="3"
                  sm="2"
                  md="2"
                  class="pr-3"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="startDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        label="Tarih"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker v-model="startDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(startDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3" sm="3" md="3" class="pr-3 mt-4">
                  <v-select
                    v-model="measuresModel"
                    :items="measures"
                    label="Ölçü"
                    dense
                  />
                </v-col>

                <v-col cols="1" sm="1" md="1" class="pr-3">
                  <v-select
                    v-model="chartTypeModel"
                    :items="chartType"
                    label="Grafik"
                  />
                </v-col>

                <v-col cols="3" sm="1" md="1" class="pr-3 pt-3">
                  <v-btn color="primary" @click="getData"> Filtrele </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>

        <v-col v-if="analiysis_typeModel == 'INVERTER'" cols="12">
          <v-card>
            <v-col cols="12" class="pl-0 pr-0 pb-1">
              <v-row>
                <v-spacer />

                <v-col
                  v-if="
                    reportTypeModel === 'Monthly' || reportTypeModel === 'Daily'
                  "
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select v-model="yearModel" :items="yearList" label="Yıl" />
                </v-col>

                <v-col
                  v-if="reportTypeModel === 'Daily'"
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select
                    v-model="monthModel"
                    :items="monthList"
                    label="Ay"
                  />
                </v-col>

                <v-col
                  v-if="
                    reportTypeModel == 'Hourly' || reportTypeModel == 'Minute'
                  "
                  cols="3"
                  sm="2"
                  md="2"
                  class="pr-3"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="startDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        label="Tarih"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker v-model="startDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(startDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3" sm="2" md="2" class="pr-3">
                  <v-select
                    v-model="inverterModel"
                    :items="inverterList[santralModel_string]"
                    label="İnverter"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span
                        v-if="index === 0"
                        style="max-width: 120px"
                        class="d-inline-block text-truncate"
                        >{{ item.text }}</span
                      >
                      <span v-if="index === 1" class="grey--text text-caption"
                        >(+{{ inverterModel.length - 1 }})</span
                      >
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="2" sm="2" md="2" class="pr-3 mt-4">
                  <v-select
                    v-model="measuresModel"
                    :items="measures"
                    label="Ölçü"
                    dense
                  />
                </v-col>

                <v-col cols="1" sm="1" md="1" class="pr-3">
                  <v-select
                    v-model="chartTypeModel"
                    :items="chartType"
                    label="Grafik"
                  />
                </v-col>

                <v-col cols="3" sm="1" md="1" class="pr-3 pt-3">
                  <v-btn color="primary" @click="getData"> Filtrele </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>

        <v-col v-if="analiysis_typeModel == 'STRINGBOX'" cols="12">
          <v-card>
            <v-col cols="12" class="pl-0 pr-0 pb-1">
              <v-row>
                <v-spacer />

                <v-col
                  v-if="
                    reportTypeModel === 'Monthly' || reportTypeModel === 'Daily'
                  "
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select v-model="yearModel" :items="yearList" label="Yıl" />
                </v-col>

                <v-col
                  v-if="reportTypeModel === 'Daily'"
                  cols="3"
                  sm="1"
                  md="1"
                  class="pr-3"
                >
                  <v-select
                    v-model="monthModel"
                    :items="monthList"
                    label="Ay"
                  />
                </v-col>

                <v-col
                  v-if="
                    reportTypeModel == 'Hourly' || reportTypeModel == 'Minute'
                  "
                  cols="3"
                  sm="2"
                  md="2"
                  class="pr-3"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="startDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        label="Tarih"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker v-model="startDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(startDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="3" sm="2" md="2" class="pr-3">
                  <v-select
                    v-model="combinerBox"
                    :items="combinerboxList[santralModel_string]"
                    label="String"
                    multiple
                  >
                    <template v-slot:selection="{ item, index }">
                      <span
                        v-if="index === 0"
                        style="max-width: 120px"
                        class="d-inline-block text-truncate"
                        >{{ item.text }}</span
                      >
                      <span v-if="index === 1" class="grey--text text-caption"
                        >(+{{ combinerBox.length - 1 }})</span
                      >
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="2" sm="2" md="2" class="pr-3 mt-4">
                  <v-select
                    v-model="measuresModel"
                    :items="measures"
                    label="Ölçü"
                    dense
                  />
                </v-col>

                <v-col cols="1" sm="1" md="1" class="pr-3">
                  <v-select
                    v-model="chartTypeModel"
                    :items="chartType"
                    label="Grafik"
                  />
                </v-col>

                <v-col cols="3" sm="1" md="1" class="pr-3 pt-3">
                  <v-btn color="primary" @click="getData"> Filtrele </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-card>
            <v-col :key="componentKey" cols="12">
              <echart
                id="general-power-daily"
                class-name="widget-content"
                height="400px"
                width="100%"
                :chart-data="chartData"
              />
            </v-col>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" class="mb-15 mt-5 ml-2 mr-5">
          <v-col cols="12" class="fullgridtable pl-0 pr-0 pb-1">
            <v-card>
              <v-data-table
                :id="santralDataTable"
                dense
                :items-per-page="itemsPerPage"
                :headers="headers"
                :items="desserts"
                class="elevation-1"
              />
            </v-card>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
    <ExportDocument :export-document-open="exportDocumentOpen" />
  </div>
</template>
<script>
import * as SantralAnalysis from "@/api/Analysis/SantralAnalysis";
import Echart from "@/views/components/Echart/Chart.vue";
import moment from "moment";
import ExportDocument from "@/views/components/Shared/ExportDocument.vue";
import i18n from "@/locale";

import {
  getSantralMinute,
  getSantralHourly,
  getSantralDaily,
  getSantralMonthly,
  getSantralYearly,
} from "@/api/Request/santral";

import {
  stringboxMinute,
  stringboxHourly,
  stringboxDaily,
  stringboxMonthly,
  stringboxYearly,
} from "@/api/Request/stringbox";

import {
  inverterHourly,
  inverterMinute,
  inverterDaily,
  inverterMonthly,
  inverterYearly,
} from "@/api/Request/inverter";

export default {
  name: "GeneralStatsHour",
  components: {
    Echart,
    ExportDocument,
  },
  data: () => ({
    chartData: {},
    startDate: moment().format("YYYY-MM-DD"),
    finishDate: moment().format("YYYY-MM-DD"),
    menu: false,
    modal: false,
    menu2: false,
    measuresModel: "DailyEnergy",
    itemsPerPage: 500,
    yearModel: parseInt(moment().format("YYYY")),
    monthModel: parseInt(moment().format("MM")),
    measures: [],
    chartType: ["line", "bar"],
    chartTypeModel: "line",
    componentKey: 1,
    headers: [],
    desserts: [],
    reportTypeModel: "Minute",
    reportType: [],
    weekListModel: 10,
    weekList: [],
    exportDocumentOpen: {
      open: false,
      tableID: null,
    },
    santralDataTable: "santral_Analysis_table",
    chartText: "",
    newData: "true",
    santralModel: [],
    analiysis_type: [
      { text: "Genel İstatistik", value: "generalStats" },
      { text: "İnverter", value: "INVERTER" },
      { text: "Stringbox", value: "STRINGBOX" },
    ],
    analiysis_typeModel: "generalStats",
    combinerBox: [],
    santralModel_string: "",
    inverterModel: [],
    santralInfo: [],
    stepTime: 10,
    riseze: "false",
  }),
  computed: {
    inverterList() {
      return this.$store.getters.inverterName;
    },
    santralDataList() {
      const { santralDataList } = this.$store.getters;
      if (santralDataList === undefined) return;
      // eslint-disable-next-line consistent-return
      return santralDataList;
    },

    yearList() {
      return this.$store.getters.clientYearList;
    },
    monthList() {
      return this.$store.getters.month;
    },
    combinerboxList() {
      return this.$store.getters.stringboxName;
    },
  },
  watch: {
    $route(from, to) {
      this.riseze = "true";
    },
    reportTypeModel() {
      this.setData();
    },
    analiysis_typeModel() {
      this.reportTypeModel = "Minute";
    },
    combinerBox() {
      const stringbox = this.santralInfo[this.santralModel_string].STRINGBOX;
      const measure_List = [];
      const measureList = [];
      const typeList = ["avg", "sum"];
      Object.keys(this.combinerBox).forEach((str) => {
        if (stringbox.hasOwnProperty(this.combinerBox[str])) {
          const tempMeasureList =
            stringbox[this.combinerBox[str]].general_measure_list;

          tempMeasureList.forEach((measure) => {
            if (measure_List.indexOf(measure.value) < 0) {
              if (typeList.indexOf(measure.formuletype) > -1) {
                measureList.push({
                  text: i18n.t(measure.text),
                  value: measure.value,
                  unit: measure.unit,
                  type: measure.type,
                });
                measure_List.push(measure.value);
              }
            }
          });
        }
      });

      this.measuresModel = measure_List[0];
      this.measures = measureList;
    },

    inverterModel() {
      const inverter = this.santralInfo[this.santralModel_string].INVERTER;
      const measure_List = [];
      const measureList = [];
      const typeList = ["avg", "sum"];
      Object.keys(this.inverterModel).forEach((str) => {
        if (inverter.hasOwnProperty(this.inverterModel[str])) {
          const tempMeasureList =
            inverter[this.inverterModel[str]].general_measure_list;

          tempMeasureList.forEach((measure) => {
            if (measure_List.indexOf(measure.value) < 0) {
              if (typeList.indexOf(measure.formuletype) > -1) {
                measureList.push({
                  text: i18n.t(measure.text),
                  value: measure.value,
                  unit: measure.unit,
                  type: measure.type,
                });
                measure_List.push(measure.value);
              }
            }
          });
        }
      });

      this.measuresModel = measure_List[0];
      this.measures = measureList;
    },
  },

  created() {},
  mounted() {
    this.measures = [
      {
        text: i18n.t("PerformanceRatio"),
        value: "PerformanceRatio",
        unit: "%",
      },
      {
        text: i18n.t("TheoreticalPower"),
        value: "TheoreticalPower",
        unit: "kW",
      },
      {
        text: i18n.t("IstantaneousPower"),
        value: "IstantaneousPower",
        unit: "kW",
      },
      {
        text: i18n.t("DailyEnergy"),
        value: "DailyEnergy",
        unit: "kW",
      },
    ];

    this.reportType = [
      { text: "Dakika", value: "Minute" },
      { text: "Saatlik", value: "Hourly" },
      { text: "Günlük", value: "Daily" },
      { text: "Aylık", value: "Monthly" },
      { text: "Yıllık", value: "Yearly" },
    ];

    const myVar1 = setInterval(myTimer1, 1000);

    const self = this;
    function myTimer1() {
      const { santral } = self.$store.getters.selectedSantralModel;
      const { santralInfo, stepTime } = self.$store.getters;

      if (santral !== undefined && Object.keys(santralInfo).length > 0) {
        self.santralModel = [santral];
        self.santralInfo = santralInfo;
        self.stepTime = stepTime;
        clearInterval(myVar1);
        self.getData();
      }
    }
  },
  methods: {
    setStatsMeasure() {
      if (["Minute", "Hourly"].indexOf(this.reportTypeModel) > -1) {
        this.measures = [
          {
            text: i18n.t("PerformanceRatio"),
            value: "PerformanceRatio",
            unit: "%",
          },
          {
            text: i18n.t("TheoreticalPower"),
            value: "TheoreticalPower",
            unit: "kW",
          },
          {
            text: i18n.t("IstantaneousPower"),
            value: "IstantaneousPower",
            unit: "kW",
          },
          {
            text: i18n.t("DailyEnergy"),
            value: "DailyEnergy",
            unit: "kW",
          },
          {
            text: i18n.t("EquivalentTrees"),
            value: "EquivalentTrees",
            unit: "",
          },
          { text: i18n.t("CO2Avoided"), value: "CO2Avoided", unit: "" },
          { text: i18n.t("BarrelsofOil"), value: "BarrelsofOil", unit: "" },
        ];
      } else {
        this.measures = [
          {
            text: i18n.t("PerformanceRatio"),
            value: "PerformanceRatio",
            unit: "%",
          },
          {
            text: i18n.t("DailyEnergy"),
            value: "DailyEnergy",
            unit: "kW",
          },
          {
            text: i18n.t("TheoreticalPower"),
            value: "TheoreticalPower",
            unit: "kW",
          },
          {
            text: i18n.t("EquivalentTrees"),
            value: "EquivalentTrees",
            unit: "",
          },
          { text: i18n.t("CO2Avoided"), value: "CO2Avoided", unit: "" },
          { text: i18n.t("BarrelsofOil"), value: "BarrelsofOil", unit: "" },
        ];
      }
    },
    exportDocument() {
      this.exportDocumentOpen.open = true;
      this.exportDocumentOpen.tableID = this.santralDataTable;
    },
    setData() {
      if (this.analiysis_typeModel === "generalStats") {
        this.setStatsMeasure();
      }

      if (this.analiysis_typeModel === "INVERTER") {
        this.setInverter();
      }

      if (this.analiysis_typeModel === "STRINGBOX") {
        this.setStringMeasure();
      }

      this.getData();
    },
    getData() {
      let headers = [{ text: "Tarih", value: "date" }];
      if (this.analiysis_typeModel === "generalStats") {
        this.santralModel.forEach((santral) => {
          headers.push({
            text: santral,
            value: santral,
          });
        });
        this.headers = headers;
        this.getSantralDataChart(this.santralModel, "santral");
      }

      if (this.analiysis_typeModel === "INVERTER") {
        headers = [{ text: "Tarih", value: "date" }];
        const inverterList = this.inverterList[this.santralModel_string];

        inverterList.forEach((inv) => {
          if (this.inverterModel.indexOf(inv.value) > -1) {
            headers.push(inv);
          }
        });
        this.headers = headers;

        this.getSantralDataChart(this.inverterModel, "INVERTER");
      }

      if (this.analiysis_typeModel === "STRINGBOX") {
        headers = [{ text: "Tarih", value: "date" }];
        const combinerBox = this.combinerboxList[this.santralModel_string];

        combinerBox.forEach((str) => {
          if (this.combinerBox.indexOf(str.value) > -1) {
            headers.push(str);
          }
        });
        this.headers = headers;
        this.getSantralDataChart(this.combinerBox, "STRINGBOX");
      }
    },
    /// / genel istatistik start
    getSantralDataChart(deviceList, deviceModelType) {
      const { measuresModel } = this;
      const { measures } = this;
      this.chartText = "";
      let measureList;
      measures.forEach((measure) => {
        if (measuresModel === measure.value) {
          measureList = measure;
        }
      });

      const formdata = this.selectedStatsParams();
      this.chartData = [];
      const self = this;
      let temp;

      let tempData;
      if (this.reportTypeModel === "Minute") {
        if (this.analiysis_typeModel === "generalStats") {
          temp = getSantralMinute(formdata);
        }

        if (this.analiysis_typeModel === "INVERTER") {
          temp = inverterMinute(formdata);
        }

        if (this.analiysis_typeModel === "STRINGBOX") {
          temp = stringboxMinute(formdata);
        }

        temp.then((_rawData) => {
          tempData = SantralAnalysis.default.set_device_minute_data(
            _rawData.data,
            measureList,
            self.chartText,
            self.chartTypeModel,
            deviceModelType,
            deviceList,
            self.stepTime
          );

          this.setOpt(tempData);
        });
      }

      if (this.reportTypeModel === "Hourly") {
        if (this.analiysis_typeModel === "generalStats") {
          temp = getSantralHourly(formdata);
        }

        if (this.analiysis_typeModel === "INVERTER") {
          temp = inverterHourly(formdata);
        }

        if (this.analiysis_typeModel === "STRINGBOX") {
          temp = stringboxHourly(formdata);
        }

        temp.then((_rawData) => {
          tempData = SantralAnalysis.default.set_device_hourly_data(
            _rawData.data,
            measureList,
            self.chartText,
            self.chartTypeModel,
            deviceModelType,
            deviceList
          );
          this.setOpt(tempData);
        });
      }
      if (this.reportTypeModel === "Daily") {
        let month;
        const m = parseInt(formdata.condiniton.month);
        m < 10 ? (month = `0${m}`) : (month = `${m}`);
        const y = formdata.condiniton.year;
        const startDate = `${y}-${month}-01`;

        if (this.analiysis_typeModel === "generalStats") {
          temp = getSantralDaily(formdata);
        }

        if (this.analiysis_typeModel === "INVERTER") {
          temp = inverterDaily(formdata);
        }

        if (this.analiysis_typeModel === "STRINGBOX") {
          temp = stringboxDaily(formdata);
        }

        temp.then((_rawData) => {
          tempData = SantralAnalysis.default.set_device_daily_data(
            _rawData.data,
            measureList,
            self.chartText,
            self.chartTypeModel,
            self.reportTypeModel,
            deviceModelType,
            deviceList,
            startDate
          );
          this.setOpt(tempData);
        });
      }
      if (this.reportTypeModel === "Monthly") {
        const dateList = formdata.condiniton.date;

        if (this.analiysis_typeModel === "generalStats") {
          temp = getSantralMonthly(formdata);
        }

        if (this.analiysis_typeModel === "INVERTER") {
          temp = inverterMonthly(formdata);
        }

        if (this.analiysis_typeModel === "STRINGBOX") {
          temp = stringboxMonthly(formdata);
        }

        temp.then((_rawData) => {
          tempData = SantralAnalysis.default.set_device_monthly_data(
            _rawData.data,
            measureList,
            self.chartText,
            self.chartTypeModel,
            self.reportTypeModel,
            deviceModelType,
            deviceList,
            dateList
          );
          this.setOpt(tempData);
        });
      }

      if (this.reportTypeModel === "Yearly") {
        if (this.analiysis_typeModel === "generalStats") {
          temp = getSantralYearly(formdata);
        }

        if (this.analiysis_typeModel === "INVERTER") {
          temp = inverterYearly(formdata);
        }

        if (this.analiysis_typeModel === "STRINGBOX") {
          temp = stringboxYearly(formdata);
        }

        temp.then((_rawData) => {
          tempData = SantralAnalysis.default.set_device_yearly_data(
            _rawData.data,
            measureList,
            self.chartText,
            self.chartTypeModel,
            self.reportTypeModel,
            deviceModelType,
            deviceList,
            self.yearList
          );
          this.setOpt(tempData);
        });
      }
    },
    setOpt(tempData) {
      tempData.then((res) => {
        this.chartData = res.options;
        this.desserts = res.desserts;
        this.componentKey += 1;
      });
    },

    selectedStatsParams() {
      this.finishDate = moment(this.startDate)
        .add(1, "day")
        .format("YYYY-MM-DD");
      const { reportTypeModel } = this;
      let params = {};

      if (reportTypeModel === "Yearly") {
        this.santralDataTable = `${this.yearList[0]}-santralAnalysisDataTable`;

        params = {
          condiniton: {
            date: this.yearList,
            measures: this.measuresModel,
            maxcount: 5000,
          },
        };
      }

      if (reportTypeModel === "Monthly") {
        const monthL = [];
        for (let i = 1; i < 13; i++) {
          monthL.push(i);
        }
        this.santralDataTable = `${this.yearModel}-santralAnalysisDataTable`;

        params = {
          condiniton: {
            date: [
              {
                year: this.yearModel,
                month: monthL,
              },
            ],
            measures: this.measuresModel,
            maxcount: 5000,
          },
        };
      }

      if (reportTypeModel === "Daily") {
        this.santralDataTable = `${this.yearModel} ${this.monthModel}-santralAnalysisDataTable`;

        params = {
          condiniton: {
            year: this.yearModel,
            month: this.monthModel,
            measures: this.measuresModel,
            maxcount: 5000,
          },
        };
      }

      if (reportTypeModel === "Hourly") {
        this.santralDataTable = `${this.startDate} - ${this.finishDate}-santralAnalysisDataTable`;

        params = {
          condiniton: {
            startDate: this.startDate,
            finishDate: this.finishDate,
            measures: this.measuresModel,
            maxcount: 5000,
          },
        };
      }

      if (reportTypeModel === "Minute") {
        this.santralDataTable = `${this.startDate} - ${this.finishDate}-santralAnalysisDataTable`;

        params = {
          condiniton: {
            startDate: this.startDate,
            finishDate: this.finishDate,
            santral: this.santralModel,
            measures: this.measuresModel,
            maxcount: 5000,
          },
        };
      }

      if (this.analiysis_typeModel === "generalStats") {
        params.condiniton.santral = this.santralModel;
      }

      if (this.analiysis_typeModel === "INVERTER") {
        params.condiniton.santral = this.santralModel_string;
        params.condiniton.INVERTER = this.inverterModel;
      }

      if (this.analiysis_typeModel === "STRINGBOX") {
        params.condiniton.santral = this.santralModel_string;
        params.condiniton.STRINGBOX = this.combinerBox;
      }

      return params;
    },

    /// / genel istatistik finish

    setStringMeasure() {
      this.measure_List = [];
      const measure_List = [];
      const measureList = [];
      this.dcVoltageData = [];
      this.measuresModel = [];
      this.dcVoltageDataDisplay = false;

      this.santralModel_string = this.santralDataList[0];
      const stringbox = this.santralInfo[this.santralModel_string].STRINGBOX;
      this.inverterModel = [];
      const temp_str = Object.keys(stringbox)[0];
      this.combinerBox.push(temp_str);

      const tempMeasureList =
        stringbox[this.combinerBox[0]].general_measure_list;

      tempMeasureList.forEach((measure) => {
        if (measure_List.indexOf(measure.value) < 0) {
          measureList.push({
            text: i18n.t(measure.text),
            value: measure.value,
            unit: measure.unit,
            type: measure.type,
          });
          measure_List.push(measure.value);
        }
      });
      this.measuresModel = measure_List[0];
      this.measures = measureList;
    },

    setInverter() {
      this.chartData = {};
      const measureList = [];
      const measure_List = [];
      this.santralModel_string = this.santralDataList[0];
      const inverter = this.santralInfo[this.santralModel_string].INVERTER;

      this.inverterModel = [];
      const temp_inv = Object.keys(inverter)[0];
      this.inverterModel.push(temp_inv);

      const tempMeasureList =
        inverter[this.inverterModel[0]].general_measure_list;
       const typeList = ["avg", "sum"];
      tempMeasureList.forEach((measure) => {
        if (measure_List.indexOf(measure.value) < 0) {
          measureList.push({
            text: i18n.t(measure.text),
            value: measure.value,
            unit: measure.unit,
            type: measure.type,
          });
          measure_List.push(measure.value);
        }
      });
      this.measuresModel = measure_List[0];
      this.measures = measureList;
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick().then(() => {
        this.renderComponent = true;
      });
    },
  },
};
</script>

<style scoped>
.theme--dark
  .fullgridtable
  .theme--light.v-data-table
  tbody
  tr:not(:last-child) {
  border-bottom: none;
}

.fullgridtable .v-data-table th {
  border: thin solid #0000001f;
}

.fullgridtable .v-data-table td {
  border: thin solid #0000001f;
}

.fullgridtable.theme--dark .v-data-table th,
.fullgridtable.theme--dark .v-data-table td {
  border: thin solid hsla(0, 0%, 100%, 0.12);
}

.fullgridtable .theme--light.v-data-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.fullgridtable.fullorder .v-data-table th,
.fullgridtable.fullorder .v-data-table td {
  border-bottom: 0 !important;
}

.fullgridtable.fullorder .v-data-table td:not(:last-child),
.fullgridtable.fullorder .v-data-table th:not(:last-child) {
  border-right: 0 !important;
}
</style>
